import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import fontColor from "../fontColor";
import LoadingComponent from "../LoadingComponent";

/**
 * Dialog ยืนยัน/ยกเลิกทั่วไป ใช้แทน 4 modal ที่หน้าตาเกือบเหมือนกันเป๊ะซึ่งซ้ำกันทั้งใน
 * CreatePortal.jsx และ EditPortal.jsx:
 *   1) ยืนยันยกเลิกฟอร์ม (canclecreateportalmodal)
 *   2) ยืนยันบันทึกฟอร์ม (acceptcreateportalmodal) — มี loading spinner ตอนกำลังบันทึก
 *   3) ยืนยันสลับสถานะ Active/Inactive (switchactiveportal)
 *   4) ยืนยันยกเลิกการแก้ไขธีม (canclecreatethemeportalmodal) — มีไอคอนแจ้งเตือนด้านบน
 *
 * ของเดิมแต่ละ modal มีรายละเอียด style เล็ก ๆ ไม่ตรงกัน (ขนาด box, fontWeight,
 * ระยะ margin, boxShadow) — ผมคง prop ให้ override ค่าพวกนี้ได้ทีละจุด โดยตั้ง default
 * ตรงกับ modal ที่พบบ่อยที่สุด (ยืนยันบันทึก/สลับสถานะ) แล้วให้ modal อื่นสั่ง override
 * เฉพาะจุดที่ต่างจริง เพื่อให้ผลลัพธ์บนหน้าจอเหมือนเดิมทุก pixel
 */
const ConfirmDialog = ({
    open,
    onClose,
    icon, // optional — React node เช่น <ErrorIcon ... /> แสดงเหนือ title
    title,
    message,
    primaryColor,
    onCancel, // default: onClose
    onConfirm,
    cancelLabel = 'ยกเลิก',
    confirmLabel = 'ยืนยัน',
    loading = false, // true = แสดง spinner แทนข้อความ และ disable ปุ่มยืนยัน
    boxHeight = '160px',
    boxShadow, // ไม่ระบุ = ไม่มีเงา (ตรงกับ modal ยกเลิกฟอร์ม/ยกเลิกธีม)
    titleMarginTop = '12px',
    titleFontWeight = '700',
    buttonRowMarginTop = '15px',
    buttonRowFontSize = '14px',
    buttonRowFontWeight = '800', // ส่ง null เพื่อไม่ set fontWeight เลย (ตรงกับ modal ยกเลิกธีม)
    cancelMarginRight = '15px',
}) => (
    <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '344px',
                height: boxHeight,
                ...(boxShadow ? { boxShadow } : {}),
                background: '#FFFFFF',
                borderRadius: '12px',
                p: 2,
            }}
        >
            {icon && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                    {icon}
                </div>
            )}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontFamily: 'Sarabun',
                    fontWeight: titleFontWeight,
                    color: primaryColor,
                    marginTop: titleMarginTop,
                }}
            >
                {title}
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontFamily: 'Sarabun',
                    fontWeight: '400',
                    marginTop: '15px',
                    color: '#757575',
                }}
            >
                {message}
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: buttonRowMarginTop,
                    fontSize: buttonRowFontSize,
                    ...(buttonRowFontWeight != null ? { fontWeight: buttonRowFontWeight } : {}),
                }}
            >
                <button
                    style={{
                        width: '87px',
                        height: '32px',
                        border: `1px solid ${primaryColor}`,
                        borderRadius: '6px',
                        color: primaryColor,
                        backgroundColor: '#ffffff',
                        marginRight: cancelMarginRight,
                    }}
                    onClick={onCancel || onClose}
                >
                    {cancelLabel}
                </button>
                <button
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '87px',
                        height: '32px',
                        border: 'none',
                        borderRadius: '6px',
                        color: fontColor(primaryColor),
                        backgroundColor: primaryColor,
                    }}
                    disabled={loading}
                    onClick={onConfirm}
                >
                    {loading ? <LoadingComponent width={50} height={50} /> : confirmLabel}
                </button>
            </div>
        </Box>
    </Modal>
);

export default ConfirmDialog;